module.exports = __webpack_public_path__ + "files/alternate.e4331e23f1caca91c593feda8fa62fed.png";